module.exports = __webpack_public_path__ + "static/media/logo_login.dad520c3.jpg";